import React from 'react';
import logo from 'assets/act-logo.png';
import { StyledSection } from './styles';

type LogoProps = {
  url?: string;
};
const Logo = ({ url }: LogoProps): React.ReactElement => {
  return (
    <StyledSection>
      <picture>
        {url ? <source srcSet={url} /> : null}
        <img src={logo} alt="Amazon Customs and Trade Logo" />
      </picture>
    </StyledSection>
  );
};

export default Logo;
